import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1b6466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative w-full flex justify-center flex-col items-center h-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature-bg sticky bg-opacity-80" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:mt-302px mt-32 px-4 md:px-0 text-white sm:text-32px text-2xl leading-8 font-Roboto-Medium max-w-1200px mx-auto" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-max" }, " About us ")
  ])
], -1))
const _hoisted_3 = { class: "w-full xl:w-1200px h-full" }

import { ref, onMounted, Ref } from 'vue'
import ProcessBar from './ProcessBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Features',
  props: {
    scrollTop: null
  },
  setup(__props: any) {

const props = __props as {
  scrollTop: number
};


const featureDesc:any = {
  0: 'The world is rapidly moving towards a decentralized and open web, where information flows freely and is stored permanently. Arweave is leading the way in this transformation with its innovative Storage-based Consensus Paradigm (SCP) that enables on-chain, scalable storage with guaranteed persistence.',
  1: 'The potential of Arweave goes far beyond just storage, however. By decoupling storage and computation, Arweave unlocks a new era of open applications via a productive and persistent storage-based consensus paradigm at its base layer, leading to a truly decentralized and open web where users have complete control over their data and can access it anywhere, anytime.',
  2: 'As a Layer0 network with permanent storage, Arweave offers a unique opportunity for applications to be built on a trustful and censorship-resistant platform. SCP is the optimal solution for DApps in the Web3 era, providing high performance with uncapped TPS while ensuring data traceability and monopoly-free. By leveraging SCP, DApps can achieve high performance and scalability while ensuring security, traceability, and transparency.',
  3: 'Applying SCP will unlock new possibilities for decentralized and democratic storage and hosting solutions not subject to censorship or monopoly. Arweave SCP Ventures are committed to identifying and investing in innovative projects that harness SCP consensus to build the next generation of DApps, from social to finance, bringing transparency, security, and scalability to the Web3 era. And this is just the beginning.'
}
const getElementTop = (element: any) => {
  let actualTop = element.offsetTop
  let current = element.offsetParent

  while (current !== null) {
    actualTop += current.offsetTop
    current = current.offsetParent
  }

  return actualTop
}
const featureBoxDom: Ref<Element | null> = ref(null)
const stickyIndex = ref(0)
const featureRefs: Ref<Element[]> = ref([])
const featureDetailRefs: Ref<Element[]> = ref([])

const distancePercents = ref([0, 0, 0, 0])

const getFeatureWrapperRefs = (el: any) => {
  featureRefs.value.push(el)
}

const getFeatureDetailRefs = (el: any) => {
  featureDetailRefs.value.push(el)
}

const touchIndex = (index: number) => {
  if (featureRefs.value[index]) {
    featureRefs.value[index]?.scrollIntoView({ behavior: 'smooth' })
  }
}

const toPortfolio = () => {
  document.getElementById('portfolio')?.scrollIntoView({ behavior: 'auto' })
}

const featureOffsetTop = ref(0)
const offsetTops = ref<any[]>([])
onMounted(() => {
  featureOffsetTop.value = featureBoxDom.value?.getBoundingClientRect().top ?? 0
  const setOffsetTops = () => {
    // const length = featureRefs.value.length
    return featureRefs.value.map((el) => {
      // 64 是 header 高度
      return getElementTop(el)
    })
  }
  offsetTops.value = setOffsetTops()
  const itemOffsetHeight = featureDetailRefs.value[0]?.clientHeight
  window.addEventListener('resize', () => {
    offsetTops.value = setOffsetTops()
  })
  window.addEventListener('scroll', () => {
    offsetTops.value = setOffsetTops()
    offsetTops.value.forEach((offsetTop, index) => {
      if ((props.scrollTop) >= offsetTop) {
        stickyIndex.value = index
        const dis = (props.scrollTop - offsetTop) / itemOffsetHeight
        if (stickyIndex.value === offsetTops.value.length - 1) {
          distancePercents.value[index] = dis * 0.01
        } else {
          distancePercents.value[index] = dis >= 0.69 ? 1 : dis
        }
      } else {
        distancePercents.value[index] = 0
      }
    })
    featureOffsetTop.value = featureBoxDom.value?.getBoundingClientRect().top ?? 0
  }, { passive: true })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        id: "featureBox",
        ref_key: "featureBoxDom",
        ref: featureBoxDom,
        class: "max-w-1200px w-full mx-auto px-4 md:px-0"
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n, index) => {
          return _createElementVNode("div", {
            key: n,
            ref_for: true,
            ref: getFeatureWrapperRefs,
            class: "feature-wrapper"
          }, [
            _createElementVNode("div", {
              ref_for: true,
              ref: getFeatureDetailRefs,
              class: _normalizeClass(["flex flex-row items-center justify-center h-full", `${stickyIndex.value >= index ? 'top-0' : ''}`]),
              style: _normalizeStyle(`
        --distance-percent: ${distancePercents.value[index]};
        `)
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass([stickyIndex.value === 0 ? 'mt-0' : 'mt-8', "feature-problem font-Roboto-Regular sm:text-xl text-sm leading-7 text-white text-opacity-0.85 flex items-center md:mt-20 justify-center h-full"])
                }, _toDisplayString(featureDesc[index]), 3)
              ])
            ], 6)
          ])
        }), 64))
      ], 512)
    ]),
    (stickyIndex.value !== 3)
      ? (_openBlock(), _createBlock(ProcessBar, {
          key: 0,
          "distance-percents": distancePercents.value,
          onTouchIndex: touchIndex,
          onToPortfolio: toPortfolio
        }, null, 8, ["distance-percents"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})